import http from "@/shared/services/http";

export const listPositionShipper = (params: any) => http.get(`v1/positions`, { params });